
// Other
import { redirect } from 'react-router-dom';
import { getEnvironmentApiUrl } from './General';

// returns the current user logged in
export const getUser = () => {
    const userStr = localStorage.getItem('user') || '{}';
    if(userStr === 'undefined') return null;
    return JSON.parse(userStr);
};

interface HospitalData {
    hospital_token: string
    hospital_refresh_token: string
}

export const getRefreshToken = () => {
    if (window.config.THIRD_PARTY_LOGIN === false) return localStorage.getItem('refresh-token');
    const hospitalData = localStorage.getItem('hospitalData');
    if (window.config.THIRD_PARTY_LOGIN === true && hospitalData)
        return (JSON.parse(hospitalData) as HospitalData).hospital_refresh_token;
    return false;
};


//returns the number of ms the token will remain valid
export const getRefreshTimeToken = () => {
    const tokenExpirationDate = localStorage.getItem('refresh-token-expiration-date') || '';
    const expirationDate = new Date(tokenExpirationDate);
    const now = new Date();

    return expirationDate.getTime() - now.getTime();
};

// checks whether the user is authenticated. If so, returns the token, otherwise redirects
// the user to the login page.
export const checkAuthenticatedLoader = () => {
    const token = getRefreshToken();

    if (!token || getRefreshTimeToken() < 0) {
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        if (code)
            return redirect('/validatelogin?code_auth=' + code);
        else return window.config.THIRD_PARTY_LOGIN && window.config.HOSPITAL_LOGIN_URL ?
            redirect(window.config.HOSPITAL_LOGIN_URL)
            :
            redirect('/login');
    }

    return token;

};

// logs out the user
export const LogoutAction = async () => {

    if (window.config.THIRD_PARTY_LOGIN === true) {
        const response = await fetch(getEnvironmentApiUrl() + 'Login/LogoutKeycloak/' + getRefreshToken(), {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', api_key: 'digitomedica' },
            body: null,
        });

        if (!response.ok) {
            const data = await response.json();
            console.log(data);
            redirect('/');
            return;
        }
    }

    localStorage.removeItem('user');
    localStorage.removeItem('refresh-token-expiration-date');
    localStorage.removeItem('refresh-token');
    localStorage.removeItem('hospitalData');
    return redirect('/');
};

// Checks whether the user is authenticated to access Ubikare. If so, returns the token, otherwise redirects 
export const ubikareAuthenticatedLoader = ({ request }: { request: Request }) => {
    const token = getRefreshToken();
    if (!token || getRefreshTimeToken() < 0) {
        const url = new URL(request.url);
        return redirect(`/login?redirectTo=${encodeURIComponent(url.pathname)}`);
    }
    return token;
};